import { httpClient, httpClientPortal } from '@/network/clientController'

/** Get Exchanged amount
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchange
*/
export const exchangeAmount = payload => {
	return httpClient({
		method: 'GET',
		url: 'exchange',
		params: payload,
		isCancellable: true
	})
}

/** Get Exchange Table List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetable
*/
export const requestExchangeTableList = payload => {
	return httpClient({
		method: 'GET',
		url: 'exchange/table',
		params: payload,
		isCancellable: true
	})
}

/** Get Exchange Table Filtered with value
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetablewithvalue
*/
export const requestExchangeTableWithValue = payload => {
	return httpClient({
		method: 'GET',
		url: 'exchange/tablewithvalue',
		params: payload,
		isCancellable: true
	})
}

/** Get Exchange Table List
@docs https://issue.inm.pt/projects/c00231-bai-ao-site-institucional/wiki/GET_exchangetable
*/
export const requestNonAuthenticatedExchangeTableList = payload => {
	return httpClientPortal({
		method: 'GET',
		url: 'exchange/table',
		params: payload,
		isCancellable: true
	})
}

/** Get Exchange Table Filtered with value
@docs Não há documentação, mas será semalhante a esta: https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetablewithvalue
*/
export const requestNonAuthenticatedExchangeTableWithValue = payload => {
	return httpClientPortal({
		method: 'GET',
		url: 'exchange/tablewithvalue',
		params: payload,
		isCancellable: true
	})
}
